import { render, staticRenderFns } from "./InvestmentInfo.vue?vue&type=template&id=220d0223"
import script from "./InvestmentInfo.vue?vue&type=script&lang=js"
export * from "./InvestmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports